import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import isInternetExplorerBefore from './utils/ieDetection';
import shareCountFactory from './utils/shareCountFactory';

function getGooglePlusShareCount(shareUrl, callback) {
  if (isInternetExplorerBefore(11)) {
    /* eslint-disable no-console */
    console.error('Google plus share count is not supported in <=IE10!');
    /* eslint-enable no-console */
    return;
  }

  var xhr = new XMLHttpRequest();

  xhr.open('POST', 'https://clients6.google.com/rpc');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');

  xhr.send(_JSON$stringify({
    method: 'pos.plusones.get',
    id: 'p',
    params: {
      nolog: true,
      id: shareUrl,
      source: 'widget',
      userId: '@viewer',
      groupId: '@self'
    },
    jsonrpc: '2.0',
    key: 'p',
    apiVersion: 'v1'
  }));

  xhr.onload = function onSuccessdata() {
    var data = JSON.parse(this.responseText);
    callback(data ? data.result.metadata.globalCounts.count : undefined);
  };

  xhr.onerror = function onErrordata() {};
}

export default shareCountFactory(getGooglePlusShareCount);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/GooglePlusShareCount.js
// module id = 1671
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21